import { IServer, Server } from '@module/license/models';
import { requestOperationalUsageGet, requestServerDelete, requestServerGet, requestServerPost, requestServerPut } from '@service/hardwareDataService';
import { Option } from 'react-select';

export const SERVER_GET_REQUEST = 'SERVER_GET_REQUEST';
export const SERVER_GET_SUCCESS = 'SERVER_GET_SUCCESS';
export const SERVER_GET_ERROR = 'SERVER_GET_ERROR';
export const SERVER_ADD_REQUEST = 'SERVER_ADD_REQUEST';
export const SERVER_EDIT_ROW = 'SERVER_EDIT_ROW';
export const SERVER_UPDATE_REQUEST = 'SERVER_UPDATE_REQUEST';
export const SERVER_UPDATE_SUCCESS = 'SERVER_UPDATE_SUCCESS';
export const SERVER_UPDATE_ERROR = 'SERVER_UPDATE_ERROR';
export const SERVER_DELETE_REQUEST = 'SERVER_DELETE_REQUEST';
export const SERVER_DELETE_SUCCESS = 'SERVER_DELETE_SUCCESS';
export const SERVER_DELETE_ERROR = 'SERVER_DELETE_ERROR';
export const SERVER_DESCRIPTION_UPDATE = 'SERVER_DESCRIPTION_UPDATE';
export const SERVER_SERVERID_UPDATE = 'SERVER_SERVERID_UPDATE';
export const SERVER_OPERATIONAL_UPDATE = 'SERVER_OPERATIONAL_UPDATE';
export const SERVER_RESET_CURRENTLY_EDITING = 'SERVER_RESET_CURRENTLY_EDITING';
export const SERVER_CANCEL_EDITING = 'SERVER_CANCEL_EDITING';
export const OPERATIONAL_USAGE_GET_REQUEST = 'OPERATIONAL_USAGE_GET_REQUEST';
export const OPERATIONAL_USAGE_GET_SUCCESS = 'OPERATIONAL_USAGE_GET_SUCCESS';
export const OPERATIONAL_USAGE_GET_ERROR = 'OPERATIONAL_USAGE_GET_ERROR';
export const SERVER_CLEAR_ERROR = 'SERVER_CLEAR_ERROR';

export function onServerGetRequest(siteId: number, accessToken: string) {
  return (dispatch: any) => {
    makeServerGetRequest(dispatch, siteId, accessToken);
  };
}

export function onOperationalUsagesGetRequest(accessToken: string) {
  return (dispatch: any) => {
    makeOperationalUsagesGetRequest(dispatch, accessToken);
  };
}

export function onServerResponseSuccess(site: any) {
  return {
    type: SERVER_GET_SUCCESS,
    server: site.server,
    services: site.services
  };
}

export function onOperationalUsagesResponseSuccess(operationalUsages: any) {
  return {
    type: OPERATIONAL_USAGE_GET_SUCCESS,
    operationalUsages
  };
}

export function onServerResponseError() {
  return {
    type: SERVER_GET_ERROR,
    text: 'Error receiving data'
  };
}

export function onOperationalUsagesResponseError() {
  return {
    type: OPERATIONAL_USAGE_GET_ERROR,
    text: 'Error receiving data'
  };
}

export function onAddNewEditableRow(server: IServer[], siteId: number) {
  return (dispatch: any) => {
    dispatch({
      type: SERVER_RESET_CURRENTLY_EDITING,
      server
    });
    dispatch({
      type: SERVER_ADD_REQUEST,
      server,
      newServer: new Server(siteId)
    });
  };
}

export function onEditExistingRow(server: IServer) {
  return (dispatch: any) => {
    dispatch({
      type: SERVER_RESET_CURRENTLY_EDITING,
      server
    });
    dispatch({
      type: SERVER_EDIT_ROW,
      serverToEdit: server
    });
  };
}

export function onUpdateServer(server: IServer, accessToken: string) {
  return (dispatch: any) => {
    dispatch({ type: SERVER_UPDATE_REQUEST, serverToUpdate: server });
    makeServerPutRequest(dispatch, server, accessToken);
  };
}

export function onUpdateServerResponseSuccess(siteId: number, accessToken: string) {
  return (dispatch: any) => {
    makeServerGetRequest(dispatch, siteId, accessToken);
  };
}

export function onUpdateServerResponseError() {
  return {
    type: SERVER_UPDATE_ERROR,
    text: 'Error receiving data'
  };
}

export function onDeleteServer(server: IServer, accessToken: string) {
  return (dispatch: any) => {
    dispatch({ type: SERVER_DELETE_REQUEST, serverToDelete: server });
    makeServerDeleteRequest(dispatch, server, accessToken);
  };
}

export function onDeleteServerResponseSuccess(server: IServer) {
  return (dispatch: any) => {
    dispatch({
      type: SERVER_DELETE_SUCCESS,
      server
    });
  };
}

export function onDeleteServerResponseError() {
  return {
    type: SERVER_DELETE_ERROR,
    text: 'Error receiving data'
  };
}

export function makeServerGetRequest(dispatch: any, siteId: number, accessToken: string) {
  dispatch({ type: SERVER_GET_REQUEST });
  return requestServerGet(siteId, accessToken).then(
    (success: any) => dispatch(onServerResponseSuccess(success)),
    error => dispatch(onServerResponseError())
  );
}

export function makeOperationalUsagesGetRequest(dispatch: any, accessToken: string) {
  dispatch({ type: OPERATIONAL_USAGE_GET_REQUEST });
  return requestOperationalUsageGet(accessToken).then(
    (success: any) => dispatch(onOperationalUsagesResponseSuccess(success)),
    error => dispatch(onOperationalUsagesResponseError())
  );
}

export function makeServerPutRequest(dispatch: any, server: IServer, accessToken: string) {
  const serverUpdateOrAdd = server.id === -1 ? requestServerPost(server, accessToken) : requestServerPut(server, accessToken);
  return serverUpdateOrAdd.then(
    (success: any) =>
      dispatch(onUpdateServerResponseSuccess(server.siteId, accessToken)),
    error =>
      dispatch(onUpdateServerResponseError())
  );
}
export function onServerDescriptionEdit(newDescription: string) {
  return {
    type: SERVER_DESCRIPTION_UPDATE,
    newDescription
  };
}
export function onServerServerIdEdit(newServerId: string) {
  return {
    type: SERVER_SERVERID_UPDATE,
    newServerId
  };
}
export function onServerOperationalUseChange(value: Option) {
  return {
    type: SERVER_OPERATIONAL_UPDATE,
    value
  };
}

export function makeServerDeleteRequest(dispatch: any, server: IServer, accessToken: string) {
  return requestServerDelete(server, accessToken).then(
    (success: IServer) =>
      dispatch(onDeleteServerResponseSuccess(success)),
    error =>
      dispatch(onDeleteServerResponseError())
  );
}

export function onServerCancelEdit(server: IServer) {
  return (dispatch: any) => {
    dispatch({
      type: SERVER_CANCEL_EDITING,
      serverPreEdit: server
    });
  };
}

export function clearErrorMessage() {
  return (dispatch: any) => {
    dispatch({ type: SERVER_CLEAR_ERROR });
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/actionCreators/hardwareActionCreators.ts